import React, { useState, useEffect } from "react";
import { Table, Form, InputGroup, Button, Dropdown } from "react-bootstrap";
import { FaSearch, FaCopy, FaCheck, FaTimes } from "react-icons/fa";
import MRModal from "./modals/MatchReportModal";
import { fetchMatchReport } from "./Api";

function MReport() {
  const [matches, setMatches] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterSport, setFilterSport] = useState("All Sports");
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    async function loadReports() {
      try {
        const data = await fetchMatchReport();
        setMatches(data);
      } catch (err) {
        console.error("Error fetching match reports:", err);
      }
    }
    loadReports();
  }, []);

  const filteredMatches = matches.filter((match) => {
    const sportMatch =
      filterSport === "All Sports" || match.sport_name === filterSport;
    const searchMatch = match.match_history_id
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return sportMatch && searchMatch;
  });

  const handleRowClick = (match) => {
    setSelectedMatch(match);
    setShowModal(true);
  };

  const copyToClipboard = (id) => {
    navigator.clipboard.writeText(id);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div
      className="p-4 w-100"
      style={{
        backgroundColor: "#ff9b45",
        color: "#FFECC8",
        minHeight: "100%",
        boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      }}
    >
      <h5 className="mb-4 fw-bold">Match Report</h5>

      <div className="d-flex mb-3 gap-2">
        <InputGroup>
          <Form.Control
            placeholder="Search by Match ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}

          />
          <Button
            variant="outline-secondary"
            style={{ backgroundColor: "#FF7F50", color: "white" }}
          >
            <FaSearch />
          </Button>
        </InputGroup>
        <Dropdown onSelect={(eventKey) => setFilterSport(eventKey)}>
          <Dropdown.Toggle
            variant="outline-secondary"
            style={{
              backgroundColor: "transparent",
              color: "#FFECC8",
              border: "1px solid #FFECC8",
              minWidth: 140,
            }}
          >
            {filterSport}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {[
              "All Sports",
              "🏸 Badminton",
              "⚾ Baseball",
              "Tennis",
              "Basketball",
              "Cue",
              "Volleyball",
              "Soccer",
            ].map((sport) => (
              <Dropdown.Item key={sport} eventKey={sport}>
                {sport}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Button
          variant="outline-secondary"
          style={{
            border: "1px solid #FFECC8",
            color: "#FFECC8",
            backgroundColor: "transparent",
            minWidth: 40,
          }}
          onClick={() => {
            setFilterSport("All Sports");
            setSearchTerm("");
          }}
        >
          <FaTimes size={20} />
        </Button>
      </div>

      <div
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          border: "1px solid rgba(255,255,255,0.2)",
          borderRadius: "4px",
        }}
      >
        <Table responsive hover className="mb-0" style={{ color: "#FFECC8" }}>
          <thead className="table-light">
            <tr>
              <th>Match ID</th>
              <th>Sport Name</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredMatches.map((match) => (
              <tr
                key={match.match_history_id}
                onClick={() => handleRowClick(match)}
                style={{
                  cursor: "pointer",
                  background: "transparent",
                  color: "#FFD580",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,236,200,0.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
              >
                <td>
                  {match.match_history_id}
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="ms-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(match.match_history_id);
                    }}
                  >
                    {copiedId === match.match_history_id ? <FaCheck color="green" /> : <FaCopy color="black" />}
                  </Button>
                </td>
                <td>{match.sport_name}</td>
                <td>{new Date(match.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {filteredMatches.length === 0 && (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                  No reports found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <MRModal
        show={showModal}
        onHide={() => setShowModal(false)}
        match={selectedMatch}
      />
    </div>
  );
}

export default MReport;
